import React, { forwardRef } from "react";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { Badge } from "@bookingcom/bui-react";
import { GeniusBadge } from "@bookingcom/bui-assets-react/genius";
import { FlightBadgeVariant } from "@flights/types";
import { FlightCardBadgePopoverWrapper } from "./FlightCardBadgePopoverWrapper.js";
import styles from "./FlightCardBadge.module.css";
import { FlightCardBadgeBottomSheetWrapper } from "./FlightCardBadgeBottomSheetWrapper.js";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import { splitBoundsTrackingStorage } from "../../../../utils/experiments/funnel/flights_split_bounds_us.js";
export const FlightCardBadge = forwardRef((props, ref) => {
    const { style = FlightBadgeVariant.PRIMARY, alternative = false, text, hover: _hover, attributes, isInteractive = true, ariaLabel, flightToken, isFocusable = false } = props;
    const i18n = useI18n();
    const getVariant = (style) => style === FlightBadgeVariant.BRAND_PRIMARY
        ? "brand-primary"
        : style === FlightBadgeVariant.PRIMARY
            ? "brand-primary"
            : style === FlightBadgeVariant.ACCENT
                ? "accent"
                : style === FlightBadgeVariant.CALLOUT
                    ? "callout"
                    : style === FlightBadgeVariant.CONSTRUCTIVE
                        ? "constructive"
                        : style === FlightBadgeVariant.DESTRUCTIVE
                            ? "destructive"
                            : style === FlightBadgeVariant.MEDIA
                                ? "media"
                                : style === FlightBadgeVariant.OUTLINE
                                    ? "outline"
                                    : style === FlightBadgeVariant.GENIUS
                                        ? "brand-genius-primary"
                                        : undefined;
    const { isMobile } = useUserAgent();
    const WrapperComponent = isMobile ? FlightCardBadgeBottomSheetWrapper : FlightCardBadgePopoverWrapper;
    const hover = isInteractive ? _hover : undefined;
    if (style === FlightBadgeVariant.GENIUS) {
        flightToken && splitBoundsTrackingStorage.addValue(flightToken, "genius");
        return (React.createElement(WrapperComponent, { hover: hover },
            React.createElement("span", { className: styles.geniusBadge, "aria-label": i18n.trans(t("a11y_flights_search_results_card_genius_label")), role: "img" },
                React.createElement(GeniusBadge, null))));
    }
    if (isNil(text) || isEmpty(text))
        return null;
    if (style === FlightBadgeVariant.CONSTRUCTIVE) {
        return (React.createElement(WrapperComponent, { hover: hover },
            React.createElement(Badge, { className: `${getVariant(style)} ${styles.badge}`, text: text, variant: getVariant(style), alternative: alternative, attributes: ariaLabel ? { "aria-label": ariaLabel, tabIndex: isFocusable ? 0 : undefined } : { "aria-hidden": true } })));
    }
    return (React.createElement(WrapperComponent, { hover: hover },
        React.createElement(Badge, { className: `${getVariant(style)} ${styles.badge}`, text: text, variant: getVariant(style), alternative: alternative, attributes: {
                ref,
                "aria-hidden": attributes?.["aria-hidden"],
                "aria-label": ariaLabel,
                tabIndex: isFocusable ? 0 : undefined
            } })));
});
FlightCardBadge.displayName = "FlightCardBadge";
